document.addEventListener('click', (event) => {
    const anchor = event.target.closest('a');
    if (!anchor) return;
  
    const href = anchor.getAttribute('href');
    const isInternalAnchor =
      href &&
      href.startsWith('#') &&
      !href.includes('.') &&
      !/^https?:\/\//.test(href) &&
      !href.includes('www');
  
    if (!isInternalAnchor) return;
  
    const targetId = href.slice(1);
    const targetElement = document.getElementById(targetId);
  
    if (targetElement) {
      event.preventDefault();
      targetElement.scrollIntoView({ behavior: 'smooth' });
      history.pushState(null, '', window.location.pathname); 
    }
  });